export const getWeekStart = (date) => {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day;
  return new Date(d.setDate(diff));
};

export const getWeekDays = (startDate) => {
  const days = [];
  for (let i = 0; i < 7; i++) {
    const day = new Date(startDate);
    day.setDate(startDate.getDate() + i);
    days.push(day);
  }
  return days;
};

export const getHours = () => {
  const hours = [];
  for (let i = 6; i <= 18; i++) {
    hours.push(i);
  }
  return hours;
};

export const getEventsForDay = (allEvents, date) => {
  return allEvents.filter((event) => {
    const eventDate = new Date(event.eventDate);
    return eventDate.toDateString() === date.toDateString();
  });
};

export const getEventPosition = (event) => {
  const startHour = new Date(event.startTime).getHours();
  const startMinute = new Date(event.startTime).getMinutes();
  const endHour = new Date(event.endTime).getHours();
  const endMinute = new Date(event.endTime).getMinutes();

  const startPosition = ((startHour - 6) * 60 + startMinute) / 60;
  const duration =
    ((endHour - startHour) * 60 + (endMinute - startMinute)) / 60;

  return { top: startPosition * 64, height: Math.max(duration * 64, 20) }; // 64px per hour (h-16 = 64px)
};

export const formatTime = (date) => {
  return new Date(date).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });
};
